import { useParams } from "react-router-dom";
import { CreateMemoriesService } from "services";
import { decoder, logger, modalNotification } from "utils";
import CommentForm from "components/Form/User/CommentForm";

function Comment({
  handleCloseModalComment,
  getMemorialCommentList,
  theme,
  oneSubscriptionData,
}) {
  const { id } = useParams();
  const onSubmit = async (values) => {
    try {
      let bodyData = { ...values };
      bodyData.memorialId = Number(decoder(id));
      if (bodyData.comment !== "") {
        const res = await CreateMemoriesService.MemorialCommentService(
          bodyData
        );
        const { success, message } = res;
        if (success) {
          modalNotification({
            type: "success",
            message,
          });
          handleCloseModalComment();
          getMemorialCommentList();
        }
      }
    } catch (err) {
      logger(err);
    }
  };

  return (
    <>
      <CommentForm
        onSubmit={onSubmit}
        handleCloseModalComment={handleCloseModalComment}
        theme={theme}
        subscriptionData={oneSubscriptionData}
      />
    </>
  );
}

export default Comment;
